import { ParagraphSize } from '@getaccept/lib-ui';
import type { Ref } from '@vue/composition-api';
import { computed } from '@vue/composition-api';
import { t } from '@getaccept/lib-shared/src/helpers/translation.helper';
import { ChatHelper } from '../helpers';
import type { Message } from '../types';

export const useChatMessage = (message: Ref<Message>) => {
  const text = computed(() =>
    message.value.deletedAt
      ? `${t('deleted')} ${ChatHelper.fullTimestamp(message.value.deletedAt)}`
      : message.value.text
  );

  const hasOnlyEmojis = computed(() => {
    const emojiRegex = new RegExp(
      '^(\u00a9|\u00ae|[\u2000-\u3300]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff])+$'
    );
    return emojiRegex.test(text.value);
  });

  const textSize = computed(() => {
    if (hasOnlyEmojis.value) {
      return ParagraphSize.Large;
    }
    return message.value.deletedAt ? ParagraphSize.Small : ParagraphSize.Medium;
  });

  return { text, textSize };
};
